/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import algorithmConfigurationFieldsetTemplate from './algorithm-configuration-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function AlgorithmConfigurationDirective($compile, $templateCache, $translate, $log, types, toast) {
    var linker = function (scope, element) {
        var template = $templateCache.get(algorithmConfigurationFieldsetTemplate);
        element.html(template);

        scope.onAlgorithmConfigurationCopied = function() {
            toast.showSuccess(
                $translate.instant('algorithm-configuration.id-copied-message'),
                750,
                angular.element(element).closest(".toast-parent"),
                'bottom left'
            );
        };

        $compile(element.contents())(scope);
    };

    return {
        restrict: "E",
        link: linker,
        scope: {
            algorithmConfiguration: '=',
            isEdit: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/algorithm-configuration/algorithm-configuration.directive.js